import React, { FC } from 'react';

type LinkedinProps = {
  /** The color of the icon. */
  color?: string;
};

const Linkedin: FC<LinkedinProps> = ({ color = 'currentColor' }) => (
  <svg version="1.1" viewBox="0 0 300 300" x="0px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" y="0px">
    <g>
      <path
        d="M67.7,44c0,16.2-13,29.3-29.1,29.3S9.6,60.2,9.6,44c0-16.2,13-29.3,29.1-29.3S67.7,27.8,67.7,44z M68,96.8H9.3
        v187.6H68V96.8z M161.5,96.8h-58.2v187.6h58.3v-98.5c0-54.7,70.7-59.2,70.7,0v98.5h58.5V165.6c0-92.4-104.6-89-129.2-43.5V96.8z"
        fill={color}
      />
    </g>
  </svg>
);

export default Linkedin;
